<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :before-close="beforeClose"
      :title="$t('Integrations_Salesforce_StepEvents_Dialog_Title')"
      width="30%"
      v-loading="loading"
    >
      <el-form v-if="visible" :model="eventModel" ref="form" :rules="rules">
        <form-section>
          <el-form-item
            :label="$t('Integrations_Salesforce_StepEvents_Form_Name')"
            prop="event"
          >
            <el-input v-model="eventModel.event" :disabled="isUpdate" />
          </el-form-item>
          <el-form-item
            :label="$t('Integrations_Salesforce_StepEvents_Form_EventKey')"
            prop="eventKey"
          >
            <el-input v-model="eventModel.eventKey" :disabled="isUpdate" />
          </el-form-item>
          <el-form-item
            :label="$t('Integrations_Salesforce_StepEvents_Form_SelectXpEvent')"
            prop="xpEvent"
          >
            <el-autocomplete
              :placeholder="$t('CampaignForm_Select')"
              clearable
              v-model="eventModel.xpEvent"
              :fetch-suggestions="querySearchEvents"
              :select-when-unmatched="true"
              :popper-options="{
                modifiers: [
                  hidePopover,
                  'offset',
                  'keepTogether',
                  'arrow',
                  'applyStyle'
                ]
              }"
            />
          </el-form-item>
          <el-form-item
            :label="
              $t('Integrations_Salesforce_StepEvents_Form_SelectDataExtension')
            "
            prop="dataExtension"
          >
            <el-select
              filterable
              v-model="eventModel.dataExtension"
              :disabled="isUpdate"
            >
              <el-option
                v-for="extension in model.params.enabledDataExtensions"
                :key="extension.dataExtensionId"
                :label="extension.dataExtensionName"
                :value="extension.dataExtensionId"
              />
            </el-select>
          </el-form-item>
        </form-section>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save">
          <span v-if="!isUpdate">{{ $t('RestForm_Save') }}</span>
          <span v-else>{{ $t('RestForm_Update') }}</span>
        </el-button>
      </span>
    </el-dialog>

    <form-section
      v-if="isEventsAdded"
      :title="$t('Integrations_Salesforce_StepEvents_Form_Title')"
    >
      <template slot="controls">
        <el-button type="primary" @click="visible = true"
          >{{ $t('Integrations_Salesforce_StepEvents_AddButton') }}
        </el-button>
      </template>
      <el-table :data="model.params.eventMappings">
        <el-table-column
          :label="$t('Integrations_Salesforce_StepEvents_Column_DataExtension')"
          prop="deName"
        ></el-table-column>
        <el-table-column
          :label="$t('Integrations_Salesforce_StepEvents_Column_SF_EventName')"
          prop="event"
        ></el-table-column>
        <el-table-column
          :label="$t('Integrations_Salesforce_StepEvents_Column_SF_EventKey')"
          prop="eventKey"
        ></el-table-column>
        <el-table-column
          :label="$t('Integrations_Salesforce_StepEvents_Column_XP_EventName')"
          prop="xpEvent"
        ></el-table-column>
        <rest-list-column-actions>
          <template slot-scope="scope">
            <rest-list-action
              :row="scope"
              :title="$t('RestForm_Update')"
              :click="update"
              icon="el-icon-edit-outline"
            />
          </template>
        </rest-list-column-actions>
      </el-table>
    </form-section>
    <el-card class="form-section" shadow="never" v-else>
      <div class="DataExtensionsList__Empty">
        <span class="DataExtensionsListEmpty__Warning">
          {{ $t('Integrations_Salesforce_StepEvents_BlankText') }}
        </span>
        <el-button type="primary" @click="visible = true"
          >{{ $t('Integrations_Salesforce_StepEvents_AddButton') }}
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestApi from '@/core/services/RestApi'
import { projectEndpoint } from '@/core/helpers'
import _ from 'lodash'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListAction from '@/common/components/rest/RestListAction'

export default {
  name: 'EventsStep',
  props: {
    model: {
      type: Object
    }
  },

  components: {
    RestListAction,
    RestListColumnActions,
    FormSection
  },
  mounted() {
    if (!this.model.params.hasOwnProperty('eventMappings')) {
      this.$set(this.model.params, 'eventMappings', [])
    }
    this.resetForm()
    this.toggleStep()
  },
  data() {
    return {
      visible: false,
      isUpdate: false,
      loading: false,
      eventModel: {}
    }
  },
  computed: {
    isEventsAdded() {
      return (
        this.model.params.eventMappings &&
        this.model.params.eventMappings.length > 0
      )
    },
    dataExtension() {
      if (this.eventModel.dataExtension) {
        return this.model.params.enabledDataExtensions.find(
          ext => ext.dataExtensionId === this.eventModel.dataExtension
        )
      }
      return null
    },
    emptyEventModel() {
      return {
        name: null,
        xpEvent: null,
        dataExtension: null
      }
    },
    bodyStyle() {
      return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '300px'
      }
    },
    rules() {
      return {
        event: {
          required: true
        },
        eventKey: {
          required: true
        },
        xpEvent: {
          required: true
        },
        dataExtension: {
          required: true
        }
      }
    },
    saveEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: 'integrations/salesforce/create-event',
        data: this.eventModel
      })
    }
  },
  methods: {
    toggleStep() {
      this.$emit('can-continue', { value: true })
      this.$emit('change-next', { nextBtnValue: true })
    },
    update(scope) {
      this.eventModel.event = _.clone(scope.row.event)
      this.eventModel.eventKey = _.clone(scope.row.eventKey)
      this.eventModel.xpEvent = _.clone(scope.row.xpEvent)
      this.eventModel.deName = _.clone(scope.row.deName)
      this.eventModel.deId = _.clone(scope.row.deId)
      this.eventModel.dataExtension = _.clone(scope.row.deId)
      this.visible = true
      this.isUpdate = true
    },
    resetForm() {
      let params = _.clone(this.model.params)
      delete params['mapping']
      this.eventModel = { ...this.emptyEventModel, ...params }
    },
    beforeClose() {
      this.resetForm()
      this.visible = false
      this.isUpdate = false
    },
    async save() {
      try {
        if (await this.$refs['form'].validate()) {
          if (!this.isUpdate) {
            this.model.params.eventMappings.push({
              event: this.eventModel.event,
              eventKey: this.eventModel.eventKey,
              xpEvent: this.eventModel.xpEvent,
              deName: this.dataExtension.dataExtensionName,
              deId: this.dataExtension.dataExtensionId
            })
            this.loading = false
            this.visible = false
            this.resetForm()
            this.$message({
              message: this.$t(
                'Integrations_Salesforce_StepEvents_Success_Msg'
              ),
              type: 'success'
            })
          } else {
            this.model.params.eventMappings.forEach(eventMapping => {
              if (
                this.eventModel.dataExtension === eventMapping.deId &&
                this.eventModel.deName === eventMapping.deName &&
                this.eventModel.event === eventMapping.event &&
                this.eventModel.eventKey === eventMapping.eventKey
              ) {
                eventMapping.xpEvent = _.clone(this.eventModel.xpEvent)
              }
            })
            this.visible = false
            this.resetForm()
          }
        }
      } catch (e) {}
    },
    querySearchEvents(queryString, cb) {
      const params = {
        sort: 'title'
      }

      if (queryString !== null && queryString !== '') {
        params.title = queryString
      }

      RestApi(
        projectEndpoint({
          method: 'get',
          url: 'events',
          params: params
        })
      ).then(({ data }) => {
        const list = data.map(event => {
          return {
            value: event.title,
            type: event.type
          }
        })
        cb(list)
      })
    },
    hidePopover(data) {
      const refRect = data.offsets.reference
      const headerHeight =
        document.querySelector('header > .top-container').offsetHeight || 64

      data.styles.display = refRect.bottom - headerHeight < 0 ? 'none' : 'block'

      return data
    }
  },
  watch: {
    'model.params.eventMappings': {
      handler() {
        this.toggleStep()
      }
    }
  }
}
</script>

<style scoped>
.DataExtensionsList__Empty {
  display: flex;
  flex-direction: column;
  gap: 10px;

  height: 30vh;
  min-height: 300px;

  align-items: center;
  justify-content: center;
}

.DataExtensionsListEmpty__Warning {
  font-size: 20px;
  padding: 0px 125px;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/salesforce/EventsStep.vue